import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const api = axios.create({
    headers: { "Content-Type": "application/json" }
});

export default function FirmaProteccionDatos() {

    const { token } = useParams();

    const canvasRef = useRef(null);
    const dibujando = useRef(false);

    const [firmaValida, setFirmaValida] = useState(false);
    const [loading, setLoading] = useState(false);

    const [checks, setChecks] = useState({
        felicitaciones:false,
        comercial:false,
        congresos:false,
        publicaciones:false,
        web:false
    });

    const start = e => {

        dibujando.current = true;

        const rect = canvasRef.current.getBoundingClientRect();
        const ctx = canvasRef.current.getContext("2d");

        ctx.beginPath();
        ctx.moveTo(
        (e.touches ? e.touches[0].clientX : e.clientX) - rect.left,
        (e.touches ? e.touches[0].clientY : e.clientY) - rect.top
        );
    };

    const draw = e => {

        if(!dibujando.current) return;

        const rect = canvasRef.current.getBoundingClientRect();
        const ctx = canvasRef.current.getContext("2d");

        ctx.lineTo(
        (e.touches ? e.touches[0].clientX : e.clientX) - rect.left,
        (e.touches ? e.touches[0].clientY : e.clientY) - rect.top
        );

        ctx.stroke();
    };

    const end = () => {
        dibujando.current=false;
        setFirmaValida(true);
    };

    const limpiarFirma = () => {

        const ctx = canvasRef.current.getContext("2d");

        ctx.clearRect(
        0,
        0,
        canvasRef.current.width,
        canvasRef.current.height
        );

        setFirmaValida(false);
    };

    const handleSubmit = async e => {

        e.preventDefault();

        if(!canvasRef.current) return;

        const firmaBase64 = canvasRef.current.toDataURL("image/png");

        setLoading(true);

        try {

            await api.post(`public/firma/${token}`, {

            firmaBase64: firmaBase64,
            dispositivo: "TABLET",

            consentimientoProteccionDatos: {
                felicitaciones: checks.felicitaciones,
                comercial: checks.comercial,
                congresos: checks.congresos,
                publicaciones: checks.publicaciones,
                web: checks.web
            }

            });

        window.location.href="/firma-completada";

        } catch(err){

        alert("Error al registrar firma");

        } finally{

        setLoading(false);
        }
    };

    return (

        <div className="firma-page">

        <h2>Consentimiento Protección de Datos</h2>

        <form onSubmit={handleSubmit}>

            <section className="bloque">

            <h3>Autorizaciones</h3>

            <label>
                <input
                type="checkbox"
                checked={checks.felicitaciones}
                onChange={e =>
                    setChecks({...checks,felicitaciones:e.target.checked})
                }
                />
                Felicitaciones navideñas
            </label>

            <label>
                <input
                type="checkbox"
                checked={checks.comercial}
                onChange={e =>
                    setChecks({...checks,comercial:e.target.checked})
                }
                />
                Información comercial
            </label>

            <label>
                <input
                type="checkbox"
                checked={checks.congresos}
                onChange={e =>
                    setChecks({...checks,congresos:e.target.checked})
                }
                />
                Uso de imágenes en congresos
            </label>

            <label>
                <input
                type="checkbox"
                checked={checks.publicaciones}
                onChange={e =>
                    setChecks({...checks,publicaciones:e.target.checked})
                }
                />
                Uso de imágenes en publicaciones científicas
            </label>

            <label>
                <input
                type="checkbox"
                checked={checks.web}
                onChange={e =>
                    setChecks({...checks,web:e.target.checked})
                }
                />
                Uso en web o redes sociales
            </label>

            </section>

            <section className="bloque">

            <h3>Firma del paciente</h3>

            <canvas
                ref={canvasRef}
                width={700}
                height={200}
                style={{
                border:"2px solid #000",
                touchAction:"none"
                }}
                onMouseDown={start}
                onMouseMove={draw}
                onMouseUp={end}
                onMouseLeave={end}
                onTouchStart={start}
                onTouchMove={draw}
                onTouchEnd={end}
            />

            <div style={{marginTop:10}}>
                <button
                type="button"
                onClick={limpiarFirma}
                >
                Limpiar firma
                </button>
            </div>

            </section>

            <button
            type="submit"
            disabled={!firmaValida || loading}
            >
            {loading ? "Firmando..." : "Firmar documento"}
            </button>

        </form>

        </div>
    );
}